import ReactGA from "react-ga4";
import { getUsername } from "../utils/getUsername";

const TRACKING_ID = process.env.REACT_APP_GA_ID;

export const initGA = () => {
  ReactGA.initialize(TRACKING_ID);

  const cookies = document.cookie
    .split(";")
    .map((cookie) => cookie.split("="))
    .reduce(
      (accumulator, [key, value]) => ({
        ...accumulator,
        [key.trim()]: decodeURIComponent(value),
      }),
      {}
    );

  const ga_client_id = cookies._ga?.substring(6);

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ ga_client_id });

  const username = getUsername();
  if (username !== null) {
    ReactGA.set({ username });
  }
};

export const trackPageview = (path) => {
  ReactGA.send({ hitType: "pageview", path });
};

export const trackSuccessfulLogin = () => {
  const username = getUsername();
  ReactGA.set({ username });

  ReactGA.event({
    action: "login",
    label: "successful login",
    category: "User",
  });
};
